import { ViewIds } from '@ardoq/api-types';
import {
  type BubbleChartViewSettings,
  FieldSource,
  isBubbleChartFieldInfo,
} from '@ardoq/bubble-chart';

type BubbleChartFieldSettings = Partial<
  Pick<
    BubbleChartViewSettings,
    | 'fieldSource'
    | 'selectedFieldNameX'
    | 'selectedFieldNameY'
    | 'selectedFieldNameRadius'
  >
>;

type ReferenceFieldsTrackingArgs = {
  viewId: ViewIds | null;
  isViewpointMode: boolean;
  viewSettings: BubbleChartFieldSettings;
};

type ReferenceFieldsTrackingData =
  | Record<string, never>
  | { usesReferenceFields: boolean };

export const getReferenceFieldsTrackingData = ({
  viewId,
  isViewpointMode,
  viewSettings,
}: ReferenceFieldsTrackingArgs): ReferenceFieldsTrackingData => {
  if (viewId !== ViewIds.BUBBLE) {
    return {};
  }
  const {
    fieldSource,
    selectedFieldNameX,
    selectedFieldNameY,
    selectedFieldNameRadius,
  } = viewSettings;
  return {
    usesReferenceFields:
      isViewpointMode &&
      fieldSource === FieldSource.BY_REFERENCE &&
      [selectedFieldNameX, selectedFieldNameY, selectedFieldNameRadius].some(
        isBubbleChartFieldInfo
      ),
  };
};
